/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Kit 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Navbar.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `name` key is used for the name of the route on the Navbar.
  2. The `icon` key is used for the icon of the route on the Navbar.
  3. The `collapse` key is used for making a collapsible item on the Navbar that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  4. The `route` key is used to store the route location which is used for the react router.
  5. The `href` key is used to store the external links location.
  6. The `component` key is used to store the component of its route.
  7. The `dropdown` key is used to define that the item should open a dropdown for its collapse items .
  8. The `description` key is used to define the description of
          a route under its name.
  9. The `columns` key is used to define that how the content should look inside the dropdown menu as columns,
          you can set the columns amount based on this key.
  10. The `rowsPerColumn` key is used to define that how many rows should be in a column.
*/

// @mui material components
import Icon from "@mui/material/Icon";

// @mui icons

// Pages

//import ContactUs from "layouts/pages/landing-pages/contact-us";
//import Author from "layouts/pages/landing-pages/author";
//import SignIn from "layouts/pages/authentication/sign-in";

// Sections
//import PageHeaders from "layouts/sections/page-sections/page-headers";
//import Features from "layouts/sections/page-sections/featuers";
//import Navbars from "layouts/sections/navigation/navbars";
//import NavTabs from "layouts/sections/navigation/nav-tabs";
//import Pagination from "layouts/sections/navigation/pagination";
//import Inputs from "layouts/sections/input-areas/inputs";
//import Forms from "layouts/sections/input-areas/forms";
//import Alerts from "layouts/sections/attention-catchers/alerts";
//import Modals from "layouts/sections/attention-catchers/modals";
//import TooltipsPopovers from "layouts/sections/attention-catchers/tooltips-popovers";
//import Avatars from "layouts/sections/elements/avatars";
//import Badges from "layouts/sections/elements/badges";
//import BreadcrumbsEl from "layouts/sections/elements/breadcrumbs";

import { Mail } from "@mui/icons-material";
import EscalasSalarialesPage from "pages/EscalasSalariales";
import AfiliatePage from "pages/AfiliatePage";
import DenunciasPage from "pages/DenunciasPage";
import RegistraEmpleadosPage from "pages/RegistraEmpleados";
import AfiliaEmpleadosPage from "pages/AfiliaEmpleadosPage";
import EstadoDeudaPage from "pages/EstadoDeudaPage";
import BeneficiosAfiliadosPage from "pages/BeneficiosAfilaidosPage";
import ActividadesAfiliadosPage from "pages/ActividadesAfiliadosPage";
import CursosPage from "pages/CursosPage";
import EventosPage from "pages/EspecializacionesPage";
import Verano2025Page from "pages/Verano2025";
import ApoyoEscolarPage from "pages/ApoyoEscolarPage";
import NoticiasPage from "pages/NoticiasPage";

const routes = [
  {
    name: "Tu Sindicato",
    icon: <Icon>dashboard</Icon>,
    columns: 1,
    rowsPerColumn: 2,
    collapse: [
      {
        name: "Sindicato",
        collapse: [
          {
            name: "Noticias",
            route: "/noticias",
            component: <NoticiasPage />,
          },
        ],
      },
      {
        name: "Personas",
        collapse: [
          {
            name: "Escalas Salariales",
            route: "/escalassalariales",
            component: <EscalasSalarialesPage />,
          },
          {
            name: "Afiliate",
            route: "/afiliate",
            component: <AfiliatePage />,
          },
          {
            name: "Denuncias",
            route: "/denuncias",
            component: <DenunciasPage />,
          },
        ],
      },
      {
        name: "Empresas",
        collapse: [
          {
            name: "Registra trabajadores",
            route: "/registratrabajadores",
            component: <RegistraEmpleadosPage />,
          },
          {
            name: "Afilia tu personal",
            route: "/afiliartrabajadores",
            component: <AfiliaEmpleadosPage />,
          },
          {
            name: "Estado de deuda",
            route: "/estadodeudaempresa",
            component: <EstadoDeudaPage />,
          },
        ],
      },
    ],
  },
  {
    name: "Beneficios",
    icon: <Icon>view_day</Icon>,
    collapse: [
      {
        name: "Afiliados",
        description: "Ver todos los beneficios",
        dropdown: true,
        route: "/beneficiosafiliados",
        component: <BeneficiosAfiliadosPage />,
        collapse: [
          {
            name: "Descuentos",
            route: "/beneficiosafiliados",
            component: <BeneficiosAfiliadosPage />,
          },
          {
            name: "Vouchers",
            route: "/beneficiosafiliados",
            component: <BeneficiosAfiliadosPage />,
          },
        ],
      },
      {
        name: "Actividades",
        description: "Ver todas las Actividades",
        dropdown: true,
        collapse: [
          {
            name: "Femeninas",
            route: "/actividadesafiliados?genero=femenino",
            component: <ActividadesAfiliadosPage />,
          },
          {
            name: "Masculinas",
            route: "/actividadesafiliados?genero=masculino",
            component: <ActividadesAfiliadosPage />,
          },
          {
            name: "todas las actividades",
            route: "/actividadesafiliados?genero=todas",
            component: <ActividadesAfiliadosPage />,
          },
        ],
      },
      {
        name: "Especializaciones",
        description: "Ver todas las especializaciones",
        dropdown: true,
        collapse: [
          {
            name: "cursos",
            route: "/cursos",
            component: <CursosPage />,
          },
          {
            name: "Eventos",
            route: "/especializaciones",
            component: <EventosPage />,
          },
        ],
      },
      {
        name: "Verano 2025",
        description: "Beneficios temporada verano 2025",
        dropdown: false,
        route: "/verano2025",
        component: <Verano2025Page />,
      },
      {
        name: "Apoyo escolar 2026",
        description: "Pre inscribite para recibir el apoyo escolar 2026",
        dropdown: false,
        component: <ApoyoEscolarPage />,
        route: "/apoyoescolar",
      },
    ],
  },
  {
    name: "Documentacion Legal",
    icon: <Icon>article</Icon>,
    collapse: [
      {
        name: "Convenio Colectivo",

        href: "https://drive.google.com/file/d/1X2940Hv0BHp0oWleLJbzOR_GPSLc4vBP/view?usp=sharing",
      },
      {
        name: "Acta Acuerdo",

        href: "https://drive.google.com/file/d/1ifaSCOsUazaR6WNX2z8CGyLOvDptn8U3/view?usp=sharing",
      },
      {
        name: "Acta Acuerdo Ag - Nov 2026",

        href: "https://drive.google.com/file/d/1nZhRi0nQvFrXQ5gsrQusdvwgBhma0V6y/view?usp=sharing",
      },
      {
        name: "Última Escala Salarial",

        href: "https://drive.google.com/file/d/1KKj5nSZuzEDm4teNVaVAD-MgVRazdfb3/view?usp=drive_link",
      },
      {
        name: "Acta consignacion de autoridades",

        href: "https://drive.google.com/file/d/13EOmaEtYrrf_vy1PBBxEvIIcsJAes-ff/view?usp=drive_link",
      },
    ],
  },
  {
    name: "Afiliate",
    icon: <Mail />,
    href: "/afiliate",
  },
];

export default routes;
